import { PAYMENTS_ENABLED } from "../../config/payments";

/**
 * `clientCapabilities` for createSlotHold and createBooking (rev 3, P1;
 * booking-v1 1.20.0): the claim to complete hosted Checkout, ONLY while the
 * payments gate is open. Book must never claim a capability it cannot
 * complete. Undefined with the gate closed, so the variable is omitted.
 *
 * Its own module, with nothing but the gate imported: the booking flow imports
 * it on every build, and with the gate closed it must fold to `undefined`
 * without pulling any other payments code into the entry (check-book-entry).
 */
export function clientCapabilities(): { readonly hostedCheckout: true } | undefined {
  return PAYMENTS_ENABLED ? { hostedCheckout: true } : undefined;
}
